import {
  LOADING,
  ERROR,
  SUCCESS,
  selectSendVerificationEmailStatus,
  selectCheckVerificationCodeStatus,
} from './selectors';

import { setStatus, unsetStatus } from './status';
import { PODCASTERS_SERVICE } from '../lib/Request';
import { Thunk } from '../types';

export const sendVerificationEmail = (showId: string, claimExistingShow?: boolean): Thunk => async (
  dispatch,
  getState,
  { request },
) => {
  const key = 'sendVerificationEmail';

  const endpoint = claimExistingShow
    ? `${PODCASTERS_SERVICE}/v0/shows/${showId}/claim`
    : `${PODCASTERS_SERVICE}/v0/feeds/${showId}/claim`;

  /* istanbul ignore next */
  if (selectSendVerificationEmailStatus(getState()) === LOADING) return;

  dispatch(setStatus({ [key]: LOADING }, 'claim/SEND_VERIFICATION_EMAIL_REQUEST'));

  try {
    await request.post(endpoint);
  } catch (err) {
    // do nothing if email fails to send, the user has a 'resend' option on the next view
  }
  dispatch(setStatus({ [key]: SUCCESS }, 'claim/SEND_VERIFICATION_EMAIL_SUCCESS'));
};

export const resetVerificationCodeStatus = (): Thunk => async dispatch =>
  dispatch(unsetStatus(['checkVerificationCode', 'sendVerificationEmail'], 'claim/RESET'));

export const checkVerificationCode = (
  showId: string,
  code: string,
  claimExistingShow?: boolean,
): Thunk => async (dispatch, getState, { request }) => {
  const key = 'checkVerificationCode';

  const endpoint = claimExistingShow
    ? `${PODCASTERS_SERVICE}/v0/shows/${showId}/authorization/${code}`
    : `${PODCASTERS_SERVICE}/v0/feeds/${showId}/peek/${code}`;

  /* istanbul ignore next */
  if (selectCheckVerificationCodeStatus(getState()) === LOADING) return;

  dispatch(
    setStatus(
      {
        [key]: LOADING,
      },
      'claim/VERIFICATION_CODE_REQUEST',
    ),
  );

  try {
    await request.post(endpoint);
    dispatch(
      setStatus(
        {
          [key]: SUCCESS,
        },
        'claim/VERIFICATION_CODE_SUCCESS',
      ),
    );
  } catch (err) {
    dispatch(
      setStatus(
        {
          [key]: ERROR,
        },
        'claim/VERIFICATION_CODE_ERROR',
      ),
    );
  }
};
